import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import moment from 'moment';
import { IUserProfileContext, UserProfileContext } from '../../../../../../../userProfileState/userProfileContext';

const UpdatedField = () => {
	const { userForUserInfo } = useContext<IUserProfileContext>(UserProfileContext);

	const inputValue = userForUserInfo?.updatedDate
		? `${moment(userForUserInfo.updatedDate).format('MM/DD/YYYY h:mm:ss A')}   ${userForUserInfo.updatedBy}`
		: undefined;

	return <FullInfoField label="lastUpdateLabel" value={inputValue} />;
};

export default UpdatedField;
